<template>
    <div>
        <b-row>
            <b-col cols="12" v-if="!clientId">
                <app-autocomplete
                    :items="clients"
                    label="Cliente"
                    v-model="selectedClient"
                    :required="true"
                    @change="onClientChange"
                    :has-error="$v.pet.clientId.$error"
                    error-message="Debe seleccionar el cliente"
                ></app-autocomplete>
            </b-col>
            <b-col cols="12" md="6" v-if="!venueId">
                <app-form-select-input
                    :options="venues"
                    label="Sede"
                    :required="true"
                    v-model="pet.venueId"
                    @change="onVenueChange"
                    :has-error="$v.pet.venueId.$error"
                    error-message="Debe seleccionar la sede"
                ></app-form-select-input>
            </b-col>
            <b-col cols="12" md="6">
                <app-form-select-input
                    :options="structures"
                    label="Estructura"
                    :required="true"
                    v-model="pet.structureId"
                    @change="$v.pet.structureId.$touch()"
                    :has-error="$v.pet.structureId.$error"
                    error-message="Debe seleccionar la estructura"
                ></app-form-select-input>
            </b-col>
            <b-col cols="12" md="6">
                <app-form-select-input
                    :options="species"
                    label="Especie"
                    :required="true"
                    v-model="pet.specieId"
                    @change="$v.pet.specieId.$touch()"
                    :has-error="$v.pet.specieId.$error"
                    error-message="Debe seleccionar la especie"
                ></app-form-select-input>
            </b-col>
            <b-col cols="12" md="6">
                <app-form-select-input
                    :options="specieBreeds"
                    label="Raza"
                    :required="true"
                    v-model="pet.breedId"
                    @change="$v.pet.breedId.$touch()"
                    :has-error="$v.pet.breedId.$error"
                    error-message="Debe seleccionar la raza"
                ></app-form-select-input>
            </b-col>
            <b-col cols="12" md="6">
                <app-form-text-input
                    label="Nombre"
                    :required="true"
                    v-model="pet.name"
                    @input="$v.pet.name.$touch()"
                    :has-error="$v.pet.name.$error"
                    error-message="Debe escribir el nombre"
                ></app-form-text-input>
            </b-col>
            <b-col cols="12" md="6">
                <app-form-text-input
                    type="number"
                    label="Edad (Años)"
                    v-model="pet.age"
                ></app-form-text-input>
            </b-col>
        </b-row>
        <b-row align-h="center">
            <b-col class="d-flex justify-content-center">
                <app-web-cam
                    v-if="!hasPhoto"
                    v-model="pet.photo"
                    :multiple="false"
                    id="petWebCam"
                    upload
                ></app-web-cam>
                <div
                    v-else
                    class="pet-photo"
                    :style="
                        `background-image: url(${petPhoto}); background-position: center; background-size: cover;`
                    "
                >
                    <b-btn
                        variant="danger"
                        size="sm"
                        class="pet-photo-delete"
                        @click="onDeletePhoto"
                        ><i class="fa fa-trash"></i
                    ></b-btn>
                </div>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import petsRepository from "@repositories/pets.repository";
import WebCam from "@components/UI/Controls/WebCam/WebCam";
import Autocomplete from "../../UI/Controls/AutocompleteV2/Autocomplete";
import { mapGetters } from "vuex";
export default {
    components: {
        appWebCam: WebCam,
        appAutocomplete: Autocomplete
    },
    props: {
        clientId: {
            type: Number
        },
        venueId: {
            type: Number
        }
    },
    data: () => ({
        pet: {
            id: "",
            clientId: "",
            venueId: "",
            structureId: "",
            specieId: "",
            breedId: "",
            name: "",
            age: "",
            photo: ""
        },
        selectedClient: "",
        species: [],
        breeds: [],
        venues: [],
        structures: [],
        hasPhoto: false,
        petPhoto: "",
        changePhoto: false
    }),
    validations: {
        pet: {
            clientId: { required },
            venueId: { required },
            structureId: { required },
            specieId: { required },
            breedId: { required },
            name: { required }
        }
    },
    computed: {
        ...mapGetters(["clients"]),
        specieBreeds() {
            if (!this.pet.specieId) return [];

            return this.breeds.filter(
                item => item.pet_specie_id === this.pet.specieId
            );
        }
    },
    methods: {
        loadPetInfo() {
            const pr = { ...petsRepository };
            const pr1 = { ...petsRepository };
            Promise.all([pr.species.get(), pr1.breeds.get()])
                .then(([species, breeds]) => {
                    this.species = species.data;
                    this.breeds = breeds.data;
                })
                .catch(err => this.handleErrors(err));
        },
        async save() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                return toastr.error("Debe diligenciar todos los campos");
            }
            // const pr = {...petsRepository};

            // try {
            const { data } = !this.pet.id
                ? await repo.post("pets", this.pet)
                : await repo.put(`pets/${this.pet.id}`, this.pet);

            if (data.status) {
                toastr.success("Mascota registrada correctamente");
                this.reset();
                !this.pet.id
                    ? this.$emit("pet-saved", data.pet)
                    : this.$emit("pet-updated", data.pet);
            } else {
                toastr.error(data.msg);
            }
            // } catch(err) {
            //     this.handleErrors(err);
            // } finally {
            //
            // }
        },
        onClientChange(client) {
            this.pet.clientId = !!client ? client.id : "";
            this.$v.pet.clientId.$touch();
            this.venues = [];
            this.structures = [];
            this.loadVenues(client.id);
        },
        onVenueChange(val) {
            this.$v.pet.venueId.$touch();
            this.structures = [];
            this.loadStructures(val);
        },
        async loadVenues(client, autoload = true) {
            const { data } = await repo.get("venues", { client });
            this.venues = data;
            if (autoload && data.length === 1) {
                this.pet.venueId = data[0].id;
                this.loadStructures(this.pet.venueId);
            }
        },
        async loadStructures(venue) {
            const { data } = await repo.get("structures", { venue });
            this.structures = data;
            if (data.length === 1) {
                this.pet.structureId = data[0].id;
            }
        },
        async fill(pet) {
            this.selectedClient = this.clients.find(
                item => item.id === pet.client_id
            );
            this.pet.id = pet.id;
            this.pet.clientId = pet.client_id;
            await this.loadVenues(pet.client_id, false);
            this.pet.venueId = pet.structure.venue_id;
            await this.loadStructures(pet.structure.venue_id);
            this.pet.structureId = pet.structure_id;
            this.pet.name = pet.name;
            this.pet.age = `${pet.age}`;
            // this.pet.photo = pet.photo_url;
            this.pet.specieId = pet.pet_breed.pet_specie_id;
            this.pet.breedId = pet.pet_breed_id;
            this.petPhoto = pet.photo_url;
            this.hasPhoto = true;
        },
        reset() {
            this.selectedClient = "";
            Object.keys(this.pet).map(key => (this.pet[key] = ""));
            this.hasPhoto = false;
            this.petPhoto = "";
            this.$nextTick(() => this.$v.$reset());
            this.$bus.$emit("petWebCam.off");
        },
        onDeletePhoto() {
            this.hasPhoto = false;
            this.petPhoto = "";
            this.changePhoto = true;
        },
        setClientData() {
            if (!!this.clientId) {
                this.pet.clientId = this.clientId;
                this.$v.pet.clientId.$touch();
            }
            if (!!this.venueId) {
                this.pet.venueId = this.venueId;
                this.$v.pet.venueId.$touch();
                this.loadStructures(this.venueId);
            }
        }
    },
    mounted() {
        this.loadPetInfo();
        this.setClientData();
    },
    created() {
        this.$bus.$on("petForm.clear", this.reset);
    },
    beforeDestroy() {
        this.$bus.$off("petForm.clear");
    }
};
</script>
<style lang="css">
.pet-photo {
    width: 250px;
    height: 250px;
    border-radius: 50%;
    position: relative;
}

.pet-photo-delete {
    position: absolute;
    top: 10px;
    left: 100%;
    margin-left: -20px;
}
</style>
